import type { CssVarsTheme } from '@mui/material';
import type { Components } from '@mui/material/styles';
import { outline } from './constants';

const styleOverrides: NonNullable<
  Components<CssVarsTheme>['MuiLink']
>['styleOverrides'] = {
  root: () => ({
    fontWeight: 500,
    textDecoration: 'none',

    '&:link, &:visited': {
      textDecoration: 'none',
    },

    '&:hover, &:active': {
      textDecoration: 'underline',
    },

    '&.Mui-focusVisible': {
      outline,
      outlineOffset: 4,
      outlineStyle: 'auto',
      outlineWidth: 1,
    },
  }),
};

const MuiLink: Components<CssVarsTheme>['MuiLink'] = {
  styleOverrides,
};

export default MuiLink;
